<template>
  <div class="training-with-training">
    <SOSlotBase :container-name="`TrainingWithTraining`" :loading="isLoading">
      <template v-slot:title-bar>
        <SOTitleBar
          :page-title="'Belajar Bersama Smartlink'"
          :type="'back'"
          @back="back"
        />
      </template>

      <template v-slot:content>
        <div class="bg p-y-12 d-flex">
          <div class="d-block">
            <div class="f-semi f-14">
              Mohon unduh terlebih dahulu aplikasi zoom pada perangkat anda
              sebelum meeting
            </div>
          </div>
        </div>

        <div class="bar p-x-20 remove-margin">
          <div class="keterangan d-flex-between remove-margin">
            <div class="f-14 f-regular f-c-primary p-t-16 remove-margin">
              <label class="m-d-0"> Training Saya </label>
              <div class="f-18 f-bold remove-margin">
                <b> 3 Training </b>
              </div>
            </div>

            <button
              class="btn btn-outline-primary remove-margin"
              @click="routeToRiwayat"
            >
              Riwayat Training
            </button>
          </div>
          <template>
            <div class="card-scroll-container">
              <div class="card-container">
                <div class="card card-info">
                  <div class="card-bodyinf">
                    <div class="d-flex-between">
                      <div class="labelinf">Menunggu konfirmasi CS</div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z"
                            fill="#6F7287"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="sub-bodyinf pt-1">TFO241287242</div>
                  <div class="sub-bodyinftitle pt-2">
                    Training Gratis Online
                  </div>
                  <div class="countdown">
                    <svg
                      class="custom-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_1520_19609)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00008 1.99996C4.68637 1.99996 2.00008 4.68625 2.00008 7.99996C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 7.99996C14.0001 4.68625 11.3138 1.99996 8.00008 1.99996ZM0.666748 7.99996C0.666748 3.94987 3.94999 0.666626 8.00008 0.666626C12.0502 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.05 0.666748 7.99996ZM7.99999 3.33329C8.36818 3.33329 8.66666 3.63177 8.66666 3.99996V7.58793L10.9648 8.73701C11.2941 8.90166 11.4276 9.30211 11.2629 9.63143C11.0983 9.96075 10.6978 10.0942 10.3685 9.92957L7.70185 8.59624C7.476 8.48331 7.33333 8.25247 7.33333 7.99996V3.99996C7.33333 3.63177 7.6318 3.33329 7.99999 3.33329Z"
                          fill="#808080"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1520_19609">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span class="TimeInf">4 Agustus 2023 13:00</span>
                  </div>
                </div>

                <div class="card card-info" @click="routeToUlasan">
                  <div class="card-bodyinf">
                    <div class="d-flex-between">
                      <div class="labelinf2">Selesai</div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z"
                            fill="#6F7287"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="sub-bodyinf pt-1">TFO241287242</div>
                  <div class="sub-bodyinftitle pt-2">
                    Training Gratis Online
                  </div>
                  <div class="countdown">
                    <svg
                      class="custom-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_1520_19609)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00008 1.99996C4.68637 1.99996 2.00008 4.68625 2.00008 7.99996C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 7.99996C14.0001 4.68625 11.3138 1.99996 8.00008 1.99996ZM0.666748 7.99996C0.666748 3.94987 3.94999 0.666626 8.00008 0.666626C12.0502 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.05 0.666748 7.99996ZM7.99999 3.33329C8.36818 3.33329 8.66666 3.63177 8.66666 3.99996V7.58793L10.9648 8.73701C11.2941 8.90166 11.4276 9.30211 11.2629 9.63143C11.0983 9.96075 10.6978 10.0942 10.3685 9.92957L7.70185 8.59624C7.476 8.48331 7.33333 8.25247 7.33333 7.99996V3.99996C7.33333 3.63177 7.6318 3.33329 7.99999 3.33329Z"
                          fill="#808080"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1520_19609">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span class="TimeInf">4 Agustus 2023 13:00</span>
                  </div>
                </div>

                <div class="card card-info" @click="routeToTerjadwalkan">
                  <div class="card-bodyinf">
                    <div class="d-flex-between">
                      <div class="labelinf">Terjadwalkan</div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z"
                            fill="#6F7287"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="sub-bodyinf pt-1">TFO241287242</div>
                  <div class="sub-bodyinftitle pt-2">
                    Training Gratis Online
                  </div>
                  <div class="countdown">
                    <svg
                      class="custom-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_1520_19609)">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.00008 1.99996C4.68637 1.99996 2.00008 4.68625 2.00008 7.99996C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 7.99996C14.0001 4.68625 11.3138 1.99996 8.00008 1.99996ZM0.666748 7.99996C0.666748 3.94987 3.94999 0.666626 8.00008 0.666626C12.0502 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.05 0.666748 7.99996ZM7.99999 3.33329C8.36818 3.33329 8.66666 3.63177 8.66666 3.99996V7.58793L10.9648 8.73701C11.2941 8.90166 11.4276 9.30211 11.2629 9.63143C11.0983 9.96075 10.6978 10.0942 10.3685 9.92957L7.70185 8.59624C7.476 8.48331 7.33333 8.25247 7.33333 7.99996V3.99996C7.33333 3.63177 7.6318 3.33329 7.99999 3.33329Z"
                          fill="#808080"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1520_19609">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span class="TimeInf">4 Agustus 2023 13:00</span>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="separator m-x-min m-d-20" />
          <div class="m-x-min">
            <div class="p-x-20">
              <div class="f-18 f-bold">
                <p>Program yang Tersedia</p>
              </div>

              <div class="f-0 f-regular f-c-primary p-y-5">
                <label class="m-d-0">
                  Mulai pelajari aplikasi smartowner dengan memilih
                </label>
                <br />
                <label class="m-d-0"> program yang tersedia dibawah ini </label>
              </div>
            </div>
          </div>

          <template>
            <div class="card card-free">
              <div class="card-header">
                <b class="header-text">Training Free Online</b>
                <p class="price-text">Rp 0 /pertemuan</p>
              </div>
              <div class="card-body">
                <p>
                  Ketahui bagaimana cara mengoperasikan <br />
                  aplikasi smartlink sesuai standart manajemen operasional
                  outlet
                </p>
                <b class="sub-body"> Benefit Program</b>

                <ul class="list-text">
                  <li>Cocok untuk pemula yang baru mengenal smartlink</li>
                  <li>Durasi training 45 menit</li>
                  <li>
                    Dapatkan rekan baru sesama owner laundry dari berbagai
                    daerah
                  </li>
                </ul>
                <button class="btndftr btn-primary">Daftar</button>
              </div>
            </div>

            <div class="card card-paid-online">
              <div class="card-header">
                <div class="header-content">
                  <b class="header-text">Training Berbayar Online</b>
                  <p class="price-text">Rp 500 000 /2x Pertemuan</p>
                </div>
              </div>
              <div class="card-body">
                <p>
                  Ketahui bagaimana cara mengoperasikan <br />
                  aplikasi smartlink sesuai standart manajemen <br />
                  operasional hingga manajemen laporan owner
                </p>
                <b class="sub-body"> Benefit Program</b>

                <ul class="list-text">
                  <li>
                    Cocok bagi user yang ingin belajar lebih detail secara
                    keseluruhan mengenai aplikasi smartlink
                  </li>
                  <li>Durasi training kurang lebih 2 jam</li>
                  <li>Penjelasan semua fitur Smartlink</li>
                  <li>Paket All-In <b>Rp 500.000</b> untuk 2x pertemuan</li>
                </ul>
                <button class="btndftr2 btn-primary" @click="navigatePO">
                  Daftar
                </button>
              </div>
            </div>

            <div class="card card-offline-basic">
              <div class="card-header">
                <div class="header-content">
                  <div class="label">PALING POPULER</div>
                  <b class="header-text">Training Offline Basic</b>
                  <p class="price-text">Rp 1.500.000 /4 Jam</p>
                </div>
              </div>
              <div class="card-body">
                <p>
                  Pelajari semua fitur aplikasi kasirmudah dengan <br />
                  secara intens dengan panduan dari CS kami secara langsung.
                  <br />
                  Pilih Paket program yang tersedia untuk mendapatkan
                  benefitnya.
                </p>
                <b class="sub-body"> Benefit Program</b>

                <ul class="list-text">
                  <li>Sesi training tatap muka (Kunjungan Outlet)</li>
                  <li>
                    Penjelasan semua fitur Smartlink (Aplikasi Smartowner, Kasir
                    & Produksi)
                  </li>
                  <li>Biaya Konsultasi hanya <b>Rp 1.500.000</b></li>
                  <li>Sesi waktu training 4 jam/hari (dalam 2 hari)</li>
                </ul>
                <button class="btndftr3 btn-primary" @click="navigateOB">
                  Daftar
                </button>
              </div>
            </div>

            <div class="card card-offline-allin">
              <div class="card-header">
                <div class="header-content">
                  <b class="header-text">Training Offline All-In</b>
                  <p class="price-text">Rp 3.000.000 /4 Jam</p>
                </div>
              </div>
              <div class="card-body">
                <p>
                  Pelajari semua fitur aplikasi kasirmudah dengan <br />
                  secara intens dengan panduan dari CS kami secara langsung.
                  <br />
                  Pilih Paket program yang tersedia untuk mendapatkan
                  benefitnya.
                </p>
                <b class="sub-body"> Benefit Program</b>

                <ul class="list-text">
                  <li>Sesi training tatap muka (Kunjungan Outlet)</li>
                  <li>
                    Penjelasan semua fitur Smartlink (Aplikasi Smartowner, Kasir
                    & Produksi)
                  </li>
                  <li><b>Free Aktivasi Outlet</b></li>
                  <li><b>Free Printer 58 mm</b></li>
                  <li>Biaya Konsultasi hanya <b>Rp 3.000.000</b></li>
                  <li>Sesi waktu training 4 jam/hari (dalam 2 hari)</li>
                </ul>
                <button class="btndftr4 btn-primary" @click="navigateOAI">
                  Daftar
                </button>
              </div>
            </div>
          </template>
        </div>
      </template>
    </SOSlotBase>
  </div>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
  name: "Training-Final",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOButton,
  },
  methods: {
    routeToUlasan() {
      this.$router.push("/detailTrainingSucses");
    },
    routeToRiwayat() {
      this.$router.push({ name: "riwayatTraining" });
    },
    routeToTerjadwalkan() {
      this.$router.push({
        name: "detailTraining_Terjadwalkan_TrainingOnline",
      });
    },
    navigatePO() {
      this.$router.push({ name: "pilihProgramPO" });
    },
    navigateOB() {
      this.$router.push({ name: "pilihProgramOB" });
    },
    navigateOAI() {
      this.$router.push({ name: "pilihProgramOAI" });
    },
    back() {
      this.$router.push({ name: "dashboard" });
    },
  },
};
</script>

<style scoped>
.training-with-training .separator {
  width: unset;
  height: 15px;
}
.training-with-training .d-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bg {
  background-color: #fff8e1;
  color: #6f7287;
  padding: 20px;
  display: flex;
  padding: 12px 20px;
  align-items: center;
  flex: 1 0 0;
}

.keterangan .d-flex-between .remove-margin {
  margin-bottom: 0;
}
.text-container {
  display: flex;
}
.training-with-training .text-container .epayment-container {
  width: 121px;
}
.training-with-training .text-container .reminder-container {
  width: 71px;
}

.training-with-training .card {
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin: 15px 0px;
}

.bar {
  margin-top: auto;
  margin-bottom: auto;
}
.card-info {
  display: flex;
  width: 260px /* atau 350px*/;
  padding: 10px 16px;
  border-radius: 5px;
  border: 1px solid var(--others-grey-grey-800, #ccc);
  background: #fff;
  margin-top: 0;
}

.card-free {
  background: #ccc;
}
.card-paid-online {
  background: linear-gradient(
    143deg,
    #2f957c 0%,
    rgba(76, 168, 135, 0.43) 100%
  );
}

.card-offline-basic {
  background: linear-gradient(
    143deg,
    #206cff 0%,
    rgba(52, 130, 202, 0.43) 100%
  );
  border-width: 3px;
  border-color: #206cff;
}

.card-offline-allin {
  background: linear-gradient(
    143deg,
    #7520ff 0%,
    rgba(181, 52, 202, 0.43) 100%
  );
}

.card-header {
  padding: 23px, 16px, 23px, 16px;
  gap: 8px;
  color: white;
}

.label {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 5px 6px;
  width: 150px;
  gap: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
  background-color: #f2924c;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  border-radius: 4px;
  top: 10px;
  left: 10px;
}
.labelinf {
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
  margin-top: 2px;
  margin-bottom: 0;
  border-radius: 3px;
  background: var(--warning-yellow-light, #fff8e1);
  color: #6f7287;
  top: 10px;
  left: 10px;
}
.labelinf2 {
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
  margin-top: 2px;
  margin-bottom: 0; /* Remove margin-bottom */
  border-radius: 3px;
  background: var(--warning-yellow-light, #fceeff);
  color: #6f7287;
  top: 10px;
  left: 10px;
}

.sub-bodyinftitle {
  color: var(--primary-black, #000);
  font-family: Overpass;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
}
.header-text {
  font-size: 1.5rem;
  margin: 0;
}

.price-text {
  font-size: 1.5rem;
  margin: 0;
}

.TimeInf {
  padding-left: 10px;
  color: var(--secondary-midgrey, #6f7287);
  font-family: Overpass;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.24px;
}
z .card-scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.card-container {
  display: inline-flex;
  gap: 10px;
}
.card-body {
  background-color: white;
  padding: 20px;
  text-align: start;
}

.card-bodyinf {
  background-color: white;
  padding-right: 10px;
  text-align: start;
}

.sub-body {
  font-size: 1.2rem;
  margin: 0;
  text-decoration-style: solid;
}

.sub-bodyinf {
  font-size: 1.2rem;
  text-decoration-style: solid;
}

.list-text {
  margin-top: 10px;
  padding-left: 20px;
}

.list-text li {
  margin-bottom: 8px;
  font-size: 1rem;
}

.btndftr {
  background-color: #cccc;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px, 16px;
  width: calc(100% - 10px);
  height: 40px;
}

.btndftr2 {
  background-color: #30957d;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px, 16px;
  width: calc(100% - 10px);
  height: 40px;
}

.btndftr3 {
  background-color: #206cff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px, 16px;
  width: calc(100% - 10px);
  height: 40px;
}

.btndftr4 {
  background-color: #7521ff;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px, 16px;
  width: calc(100% - 10px);
  height: 40px;
}
</style>
